import { CSSProperties, FC, MouseEvent, ReactNode } from 'react'
import cn from './index.module.css'
import { Checkbox } from 'antd'
import classNames from 'classnames'

interface ICheckboxLabel {
  label: ReactNode
  value: boolean
  disabled?: boolean
  style?: CSSProperties
  className?: string
  onChange: (value: boolean) => void
}

const CheckboxLabel: FC<ICheckboxLabel> = ({
  label,
  disabled,
  value,
  style,
  className,
  onChange,
}) => {
  const setValue = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    e.stopPropagation()
    if (disabled) return
    onChange(!value)
  }

  return (
    <button
      style={style}
      className={classNames(cn.wrapper, className)}
      onClick={setValue}
      disabled={disabled}
    >
      <Checkbox checked={value} disabled={disabled} className={cn.checkbox} />
      <span className={cn.label}>{label}</span>
    </button>
  )
}

export default CheckboxLabel
